import React from 'react';
import { connect } from 'react-redux';
import Message from 'components/shared/Message';
import Translation from 'services/translation.service';
const ErrorComponent = (props) => {

    return (
        <div className="mainWrapper">
            <Message
                success={false}
                message={Translation.key('generic_something_went_wrong_msg')}
            />
        </div>
    )
}
const mapStateToProps = state => {
    return {
        translation: state.layout.translation
    }; 
};


export default connect(
    mapStateToProps
)(ErrorComponent);